'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _WixComponent2 = require('../../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Typography = require('../../Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _RadioGroup = require('../RadioGroup.scss');

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _Focusable = require('../../common/Focusable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_WixComponent) {
  _inherits(RadioButton, _WixComponent);

  function RadioButton(props) {
    _classCallCheck(this, RadioButton);

    var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call(this, props));

    _this.id = (0, _uniqueId2.default)();
    return _this;
  }

  _createClass(RadioButton, [{
    key: 'renderButton',
    value: function renderButton() {
      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          onChange = _props.onChange,
          value = _props.value,
          icon = _props.icon,
          children = _props.children;


      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: (0, _classnames5.default)(_RadioGroup2.default.radioButton, _defineProperty({}, _RadioGroup2.default.checked, checked)),
          checked: checked,
          disabled: disabled,
          id: this.id,
          onClick: function onClick() {
            return !checked && !disabled ? onChange(value) : null;
          }
        },
        icon && _react2.default.createElement(
          'span',
          null,
          icon
        ),
        children && _react2.default.createElement(
          'span',
          null,
          children
        )
      );
    }
  }, {
    key: 'renderRadio',
    value: function renderRadio() {
      var _classnames2, _classnames3;

      var _props2 = this.props,
          checked = _props2.checked,
          children = _props2.children,
          content = _props2.content,
          disabled = _props2.disabled,
          lineHeight = _props2.lineHeight,
          name = _props2.name,
          _onChange = _props2.onChange,
          style = _props2.style,
          vAlign = _props2.vAlign,
          value = _props2.value;


      return _react2.default.createElement(
        'div',
        _extends({
          className: (0, _classnames5.default)(_RadioGroup2.default.radioWrapper, (_classnames2 = {}, _defineProperty(_classnames2, _RadioGroup2.default.disabled, disabled), _defineProperty(_classnames2, _RadioGroup2.default.checked, checked), _classnames2)),
          style: style,
          tabIndex: disabled ? null : 0,
          onFocus: this.props.focusableOnFocus,
          onBlur: this.props.focusableOnBlur
        }, (0, _Focusable.focusableStates)(this.props)),
        _react2.default.createElement('input', {
          type: 'radio',
          name: name,
          value: value,
          id: this.id,
          checked: checked,
          disabled: disabled,
          onChange: function onChange() {
            return !checked && !disabled ? _onChange(value) : null;
          }
        }),
        _react2.default.createElement(
          'label',
          {
            'data-hook': 'radio-label',
            style: { lineHeight: lineHeight },
            htmlFor: this.id,
            className: (0, _classnames5.default)(_Typography2.default[(0, _Typography.convertFromUxLangToCss)(disabled ? 'T1.4' : 'T1.1')], (_classnames3 = {}, _defineProperty(_classnames3, _RadioGroup2.default.vcenter, vAlign === 'center'), _defineProperty(_classnames3, _RadioGroup2.default.vtop, vAlign === 'top'), _classnames3))
          },
          _react2.default.createElement(
            'div',
            {
              style: { height: lineHeight },
              className: _RadioGroup2.default.radioButtonWrapper,
              'data-hook': 'radiobutton-radio'
            },
            _react2.default.createElement('div', { className: _RadioGroup2.default.radio })
          ),
          children && _react2.default.createElement(
            'div',
            { className: _RadioGroup2.default.children, 'data-hook': 'radiobutton-children' },
            children
          )
        ),
        content && _react2.default.createElement(
          'div',
          { 'data-hook': 'radio-button-content' },
          content
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.type === 'button' ? this.renderButton() : this.renderRadio();
    }
  }]);

  return RadioButton;
}(_WixComponent3.default);

RadioButton.displayName = 'RadioGroup.Radio';
RadioButton.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  vAlign: _propTypes2.default.oneOf(['center', 'top']),
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  style: _propTypes2.default.object,
  type: _propTypes2.default.oneOf(['default', 'button']),
  lineHeight: _propTypes2.default.string,

  /** optional node to be rendered under label. Clicking it will not trigger `onChange` */
  content: _propTypes2.default.node
};
RadioButton.defaultProps = {
  vAlign: 'center',
  type: 'default',
  content: null
};
exports.default = (0, _Focusable.withFocusable)(RadioButton);